export const config = {
    fulfillmentOrangeTimeTreshold: 180000,
    fulfillmentOrangePositionTreshold: 3,
    refreshFulfillmentAfterWindowNotFocusedForSeconds: 15,
};
